import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { inr } from "@/lib/api";

const statusColor = { confirmed: "#8C3A3A", created: "#595959", refunded: "#595959", paid: "#8C3A3A" };

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then(({ data }) => { setOrders(data); setLoading(false); });
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-24">
      <h1 className="font-serif font-light text-5xl md:text-7xl tracking-tight text-[#1A1A1A] mb-12">Your Orders</h1>
      {loading ? (
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#595959]">Loading…</p>
      ) : orders.length === 0 ? (
        <div>
          <p className="font-serif text-3xl text-[#595959] mb-6">No orders yet.</p>
          <Link to="/shop" className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#8C3A3A] hover:underline">Browse the collection →</Link>
        </div>
      ) : (
        <div className="space-y-6" data-testid="orders-list">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="border border-[#E5E1D8] p-6 md:p-8">
              <div className="flex justify-between items-start flex-wrap gap-3">
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#595959]">Order #{o.id.slice(0, 8)}</p>
                  <p className="font-sans text-xs text-[#595959] mt-1">{new Date(o.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>
                </div>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em]" style={{ color: statusColor[o.status] || "#595959" }}>
                  {o.status}{o.demo_mode ? " · demo" : ""}
                </span>
              </div>
              <div className="mt-5 space-y-2 border-t border-[#E5E1D8] pt-5">
                {o.items.map((i, idx) => (
                  <div key={idx} className="flex justify-between font-sans text-sm">
                    <span className="text-[#1A1A1A]">{i.name} <span className="text-[#595959]">×{i.quantity} · {i.size}</span></span>
                    <span className="font-mono">{inr(i.price * i.quantity)}</span>
                  </div>
                ))}
              </div>
              <div className="flex justify-between items-baseline border-t border-[#E5E1D8] mt-5 pt-5">
                <span className="font-serif text-xl">Total</span>
                <span className="font-mono">{inr(o.total)}</span>
              </div>
              {o.refund_eligible_until && o.status === "confirmed" && (
                <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#595959] mt-4">
                  Eligible for refund until {new Date(o.refund_eligible_until).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Orders;
